/*
 * Copyright (c) 2022. American Express Company
 */

// theirs
import React, { Children, Component, ReactComponentElement } from 'react';
import _ from 'lodash';

// ours
import SectionHeader from '../header/SectionHeader';
import { SectionViewModel } from 'src/types/view-models/section.view.model';
import FormatService from '../../services/format.service';

// styles
import styles from './Section.module.scss';

export default class Section extends Component<SectionViewModel> {
    public override render(): ReactComponentElement<any> {
        const value: string = this.props.value ? FormatService.format(this.props.value) : null;
        const dataCy: string = _.camelCase(this.props.title) + 'Section';
        return (
            <div className={styles.section} data-cy={this.props['data-cy'] || dataCy}>
                <SectionHeader
                    title={this.props.title}
                    subtitle={this.props.subtitle}
                    tooltipDescription={this.props.tooltipDescription}
                    value={value}
                />
                <div className={styles.subsection}>{this.renderSubSection(Children.toArray(this.props.children))}</div>
                {this.props.extraComp}
            </div>
        );
    }

    public renderSubSection(children: any): ReactComponentElement<any> {
        return children.map((child: any, index: number) => {
            const style: string =
                index === children.length - 1 && !this.props.borderChildComp
                    ? 'contentWithoutBorder'
                    : styles.contentWithBorder;
            const key: string = `section-${index}`;
            return (
                <div className={style} key={key}>
                    {child}
                </div>
            );
        });
    }
}
